module.exports = __webpack_public_path__ + "img/borderRightArrowWhite.24d53324.svg";